import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import MessageContext from './MessageContext';
import { clearMessage } from 'redux/actions/message';

const Message = ({ position, productId }) => {
    const dispatch = useDispatch();
    const { queue } = useSelector((state) => state.message);
    const initialState = {
        show: false,
        desc: null,
        icon: null,
        variant: null,
        target: null,
        inside: false,
        productId: null,
    };
    const [state, setstate] = useState(initialState);

    useDeepCompareEffect(() => {
        if (queue && queue.length) {
            setstate({
                ...queue[0],
                show: true,
                productId,
            });
        } else if (state && !queue.length) {
            setstate(initialState);
        }
    }, [queue, dispatch, initialState, productId, setstate, state]);

    useEffect(() => {
        if (state && state.show) {
            dispatch(clearMessage(state.messageId));
        }
    }, [state, dispatch]);

    return <MessageContext {...state} position={position} />;
};

export default Message;
